import { formatEpochDate } from 'Lib/stringHelpers';

export const getMappedColumn = (column) => {
    switch (column) {
        case 'Username':
            return 'username';
        case 'AuditDateTime':
            return 'auditTime';
        case 'ActivityType':
        case 'Description':
            return 'actType';
        case 'RequesterUsername':
            return 'requesterUsername';
        default:
            return column;
    }
};

export const formatActivitiesExport = (cell) => {
    if (cell.column.colId === 'AuditDateTime') {
        return formatEpochDate(cell.value);
    } else if (cell.column.colId === 'RequestId') {
        return `="${cell.value}"`;
    } else {
        return cell.value;
    }
};

export const formatActivitiesExportHeaders = (cell) => {
    if (cell.column.colId === 'Description') {
        return 'Description';
    } else if (cell.column.colId === 'ActivityType') {
        return 'Activity Type';
    } else {
        return cell.column.colDef.headerName;
    }
};